export enum TravelRequestEnum {
    flight = 1,
    train = 2,
    lodging = 3,
    carService = 4,
    rentalCar = 5,
    other = 6,
}

export function getTravelRequestEnumStringValue(value?: TravelRequestEnum) {
    let stringValue: string;
    switch (value) {
        case TravelRequestEnum.carService:
            stringValue = 'car service';
            break;
        case TravelRequestEnum.rentalCar:
            stringValue = 'rental car';
            break;
        case TravelRequestEnum.flight:
            stringValue = 'airfare'; // changed display name from 'flight' to 'airfare'
            break;
        default:
            stringValue = TravelRequestEnum[value];
    }
    return stringValue ?? '';
}
